import http from "../common/http-common";
import DashboardCorresponsales from "../../Interfaces/Dashboard/DashboardCorresponsales";

class Dashboard_Corresponsales_DataService {
  getCorresponsales() {
    return http.get<DashboardCorresponsales[]>(`/Dashboard/Corresponsales/Get`);
  }
  getTipoCambio(Fecha: string) {
    return http.get<number>(`/Dashboard/Corresponsales/GetTipoCambio?Fecha=${Fecha}`);
  }
}
export default new Dashboard_Corresponsales_DataService();